import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import EventIcon from '@material-ui/icons/Event';
import Typography from '@material-ui/core/Typography';
import { IGetNewEvent } from '../../../interfaces/IGetNewEvent';
import NewsAndEventsCard from '../NewsAndEventsCard';
import { IRegisterEvent } from '../../../interfaces/IRegisterEvent';


interface NewsListProps{
    data: Array<IGetNewEvent>;
}

const NewsList: React.FC<NewsListProps> = ({data}) => {
    const [url, setUrl] = useState<string | null>(null);
    const[dataAjusted, detDataAdjusted] = useState<Array<IRegisterEvent>>([]);

    const handleSeeEvent = (e: any, idEvent: number)=>{
        setUrl(`/noticias/${idEvent}`);
    }

    useEffect(()=>{
        const newdata: Array<IRegisterEvent> = data.map(obj => new IRegisterEvent(obj));
        detDataAdjusted(newdata);
    },[data])

    return(
        <>
            {
                url !== null ?
                <Redirect to={url} />
            :
                <>
                    {
                        dataAjusted.length>0 &&
                        dataAjusted.map((news:IRegisterEvent)=>(
                            <NewsAndEventsCard
                                key={news.id}
                                borderColor="#D7D7D7"
                                bgColor="#F9F9F9"
                                marginDef="10px 0"
                                icon={<EventIcon/>}
                                type={news.type}
                                highlight ={news.highlight}
                                image = {news.image}
                                name = {news.name}
                                shortDescription = {news.shortDescription}
                                publishDate={news.publishDate}
                            >
                                <Button variant="contained" className="content-btn" onClick={(e)=>handleSeeEvent(e, news.id)}>
                                    <Typography variant="h5" className="regular-serif">
                                        Ver <span className="btn-type-text">{news.type}</span>
                                    </Typography>
                                </Button>
                            </NewsAndEventsCard>
                        ))
                    }
                </>
            }
        </>
    )
}

export default NewsList
